<div class="input-group input-group-sm">
  @if ((prepend !== null) && (prepend.length > 0)) {
    <div class="input-group-prepend"><span class="input-group-text">{{prepend}}</span></div>
  }
  <input class="form-control form-control-sm text-right" type="text" placeholder="0.000000" autocomplete="off" [id]="id" [formControl]="control" (keydown)="keydown($event)" (blur)="blur($event)" (focus)="focus($event)" [disabled]="disabled" />
  <div class="input-group-append"><span class="input-group-text">%</span></div>
</div>